import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  checkDealerRemainsCart,
  createDealerRemainsOrder,
  deleteDealerRemainsCart,
  fetchDealerRemainsCart,
} from "../../api/thunks";
import {
  DealerRemainsCartResponse,
  CartSliceState,
  CreateDealerOrderResult,
} from "../types";

export const addDealerRemainsExtraReducers = (
  builder: ActionReducerMapBuilder<CartSliceState>,
) => {
  builder.addCase(fetchDealerRemainsCart.pending, (state) => {
    state.error = null;
    state.isLoadingDealerRemain = true;
  });
  builder.addCase(
    fetchDealerRemainsCart.fulfilled,
    (state, action: PayloadAction<DealerRemainsCartResponse>) => {
      const items = action.payload?.items ?? [];
      state.dealerRemainsItems = items;
      state.hasDealerRemainsCart = items.length > 0;
      state.dealerRemainsTotalPageNumber = action.payload?.totalCount ?? 0;
      if (items.length) {
        state.canCreateOrder = true;
      }
      state.isLoadingDealerRemain = false;
    },
  );
  builder.addCase(fetchDealerRemainsCart.rejected, (state, action) => {
    if (!action.meta.aborted) {
      state.error = action.payload;
      state.isLoadingDealerRemain = false;
    }
  });

  builder.addCase(checkDealerRemainsCart.fulfilled, (state, action) => {
    state.hasDealerRemainsCart = action.payload;
    if (!action.payload) {
      state.dealerRemainsItems = [];
      state.dealerRemainsTotalPageNumber = 0;
    }
  });

  builder.addCase(deleteDealerRemainsCart.fulfilled, (state) => {
    state.dealerRemainsItems = [];
    state.hasDealerRemainsCart = false;
    state.dealerRemainsTotalPageNumber = 0;
    state.selectedDealerRemainsBasketIds = [];
  });

  builder.addCase(createDealerRemainsOrder.pending, (state) => {
    state.error = null;
    state.isLoading = true;
  });
  builder.addCase(
    createDealerRemainsOrder.fulfilled,
    (state, action: PayloadAction<CreateDealerOrderResult>) => {
      state.newDealerRemainsOrder = action.payload?.data ?? [];
      state.isLoading = false;
    },
  );
  // Ошибку не пишем в state.error: CartPage показывает её в модалке результата,
  // а не заглушкой на всю страницу
  builder.addCase(createDealerRemainsOrder.rejected, (state) => {
    state.newDealerRemainsOrder = [];
    state.isLoading = false;
  });
};
